import { createTheme } from "@mui/material/styles";

const colors = {
  PRIMARY_COLOUR: "#F11218",
  SECONDARY_COLOUR: "#F84B63",
  BACKGROUND_COLOUR: "#FFFFFF",
  PAPER_BACKGROUND_COLOUR: "#FFFFFF",

  //common
  BLACK_COLOR: "#000000",
  ERROR_COLOUR: "#F86767",
  SECONDARY_TEXT_COLOR: "#8A8A8E",
  PRIMARY_TEXT_COLOR: "#FFFFFF",
  ASH_COLOR: "#F9F9F9",
  LIGHT_ASH_COLOR: "#eaeaea",
};

export default createTheme({
  palette: {
    mode: "light",
    common: {
      black: `${colors.BLACK_COLOR}`,
      ash: `${colors.SECONDARY_TEXT_COLOR}`,
      red: `${colors.ERROR_COLOUR}`,
      lightAsh: `${colors.LIGHT_ASH_COLOR}`,
    },
    primary: {
      main: `${colors.PRIMARY_COLOUR}`,
    },
    secondary: {
      main: `${colors.SECONDARY_COLOUR}`,
    },

    background: {
      paper: `${colors.PAPER_BACKGROUND_COLOUR}`,
      default: `${colors.BACKGROUND_COLOUR}`,
    },
  },
  typography: {
    fontFamily: "Poppins",
    textTransform: "none",
  },
});
